module.exports = __webpack_public_path__ + "static/media/foto@3x.3b9423dd.png";